module.exports = new __parcel__URL__("eyes_on_earth.ffd0383f.png").toString();